export function hasOrbitalPosition(sat) {
  return !!sat && Number.isInteger(Number(sat.norad_id)) && Number(sat.norad_id)>0
    && !['inactive','unavailable','stale'].includes(sat.position_status)
    && Number.isFinite(sat.lat) && Number.isFinite(sat.lon)
    && Number.isFinite(sat.alt_km) && sat.alt_km>0;
}
export function positionExplanation(sat) {
  return sat?.position_reason || 'Current position unavailable. Follow and camera views need a valid current orbit.';
}
const norm = v => {const length=Math.hypot(...v);return length>1e-9?v.map(x=>x/length):null;};
export function orbitalDirection(track) {
  for(const p of track?.ahead || []) {
    const v=p.orbital_velocity_ecf_kms;
    if(Array.isArray(v)&&v.length===3&&v.every(Number.isFinite)) {
      // Inertial orbital velocity expressed on Earth-fixed axes, mapped to Three.js axes.
      const direction=norm([v[0],v[2],-v[1]]);
      if(direction)return direction;
    }
  }
  return null;
}
export function focusDirection(mode,position,velocity=null) {
  const radial=norm(position);
  if(!radial)return [1,0,0];
  if(mode==='earth')return radial;
  if(mode==='chase'&&velocity) {
    const direction=norm(velocity);
    if(direction)return norm(radial.map((x,i)=>x*.3-direction[i])) || radial;
  }
  const tangent=norm([radial[2],0,-radial[0]]) || [1,0,0];
  return norm(radial.map((x,i)=>x*.72+tangent[i]*.69));
}
